import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { IconButton, TextField, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";

import DeleteIcon from "@mui/icons-material/Delete";
import SendIcon from "@mui/icons-material/Send";
import fieldStyles from "../../styles/fieldStyles";
import ApiService from "../../services/ApiService";
import { dbToDate, dbToTime } from "../../utils/dateTime";
import { useEffect } from "react";

export default function DialogDeleteConfirmation({
  dialogOpen,
  handleCloseDialog,
  data,
  setFailMessage,
  setOpen4,
  setOpen3,
}) {
  // Action Button
  const [sendLoad, setSendLoad] = useState(false);
  const [reason, setReason] = useState("");
  const [isDeleted, setIsDeleted] = useState(false)
  
  const handleSend = () => {
    setSendLoad(true);
    const payload = {
      type: "delete",
      reason: reason,
    };

    ApiService.deleteOrRejectIncimanlkp(data.idTblLkp, payload)
      .then((res) => {
        setSendLoad(false);
        if (!res.data.isOk) {
          setFailMessage(res.data.message);
          setOpen3(true);
          setOpen4(false);
        } else {
          window.location.reload();
        }
      })
      .catch((err) => {
        setSendLoad(false);
        console.log("err", err);
        setOpen3(true);
      });
  };

  useEffect(() => {
    if (data && data.isStatus === 'I') {
      setIsDeleted(true)
    } else {
      setIsDeleted(false)
    }

    setSendLoad(false);
  }, [data]);

  return (
    <Dialog
      open={dialogOpen}
      onClose={handleCloseDialog}
      maxWidth={"sm"}
      fullWidth={true}
    >
      <DialogTitle
        sx={{
          bgcolor: "red",
          color: "white",
          m: 2,
          p: 2,
          textAlign: "center",
          borderRadius: "5px",
        }}
      >
        {isDeleted ? 'Informasi LKP Delete' : 'Konfirmasi Delete LKP'}
      </DialogTitle>
      <DialogContent>
        {!isDeleted && 
          <>
            <span style={{ fontSize: "20px" }}>
              <b>Apakah Anda yakin untuk menghapus data ini?</b>
            </span>
            <br />
            <br />
          </>
        }
        <div
          style={{
            display: "flex",
            flexDirection: "col",
            width: "100%",
            marginBottom: "3px",
          }}
        >
          <div style={{ textAlign: "start", width: "100%" }}>
            <small>Nomor LKP : </small>
            <br />
            <span style={{ fontSize: "16px" }}>
              <b>{data.nomorLkp}</b>
            </span>
          </div>
          <div style={{ width: "100%" }}>
            <small>Waktu Kejadian :</small>
            <br />
            <span style={{ fontSize: "16px" }}>
              <b>
                {dbToDate(data.tanggalKejadian)}{" "}
                {dbToTime(data.tanggalKejadian)}
              </b>
            </span>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "col",
            width: "100%",
            marginBottom: "3px",
          }}
        >
          <div style={{ textAlign: "start", width: "100%" }}>
            <small>Judul : </small>
            <br />
            <span style={{ fontSize: "16px" }}>
              <b>{data.judulLaporan}</b>
            </span>
          </div>
          <div style={{ width: "100%" }}>
            <small>Kategori Insiden :</small>
            <br />
            <span style={{ fontSize: "16px" }}>
              <b>{data.tipeInsiden}</b>
            </span>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "col",
            width: "100%",
            marginBottom: "3px",
          }}
        >
          <div style={{ textAlign: "start", width: "100%" }}>
            <small>Lokasi : </small>
            <br />
            <span style={{ fontSize: "16px" }}>
              <b>{data.namaLokasi}</b>
            </span>
          </div>

          <div style={{ textAlign: "start", width: "100%" }}>
            <small>Region : </small>
            <br />
            <span style={{ fontSize: "16px" }}>
              <b>{data.namaRegional}</b>
            </span>
          </div>
        </div>
        <div>
          {
            !isDeleted ? (
              <>
                <div style={{ fontSize: "20px" }}>
                  <b>Alasan</b>
                </div>
                <TextField
                  id="outlined-multiline-flexible"
                  multiline
                  rows={4}
                  fullWidth
                  onChange={(event) => setReason(event.target.value)}
                />
              </>
            ) : (
              <>
                <div style={{ textAlign: "start", width: "100%" }}>
                  <small>Dihapus oleh : </small>
                  <br />
                  <span style={{ fontSize: "16px" }}>
                    <b>{data.deletedBy}</b>
                  </span>
                </div>

                <div style={{ textAlign: "start", width: "100%" }}>
                  <small>Tanggal Hapus : </small>
                  <br />
                  <span style={{ fontSize: "16px" }}>
                    <b>{dbToDate(data.deletedDate)}</b>
                  </span>
                </div>

                <div style={{ textAlign: "start", width: "100%" }}>
                  <small>Alasan Hapus : </small>
                  <br />
                  <span style={{ fontSize: "16px" }}>
                    <b>{data.deletedReason}</b>
                  </span>
                </div>
              </>
            )
          }
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseDialog} sx={{ width: "100px", m: 1 }}>
          Close
        </Button>
        <LoadingButton
          onClick={handleSend}
          loading={sendLoad}
          variant="contained"
          sx={{ width: "100px", m: 1 }}
          startIcon={<SaveIcon />}
          loadingPosition="start"
          disabled={reason.length || !isDeleted ? false : true}
        >
          SUBMIT
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
